import React from 'react';

import Paper from '@material-ui/core/Paper';
import { ErrorHarTable } from './ErrorHar';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4)
  }
}));

const UnresolvedDetails = ({ error }) => {
  const classes = useStyles();
  if (!error) return null;
  const { resolve } = error;
  return (
    <Paper elevation={0} className={classes.root}>
      <ErrorHarTable resolve={resolve} />
    </Paper>
  );
};

export default UnresolvedDetails;
